<template>
  <v-main>
    <!--    <v-snackbar bottom right :value="updateExists" :timeout="0" color="primary">-->
    <!--      An update is available-->
    <!--      <v-btn text @click="refreshApp"> Update </v-btn>-->
    <!--    </v-snackbar>-->
    <app-header :drawer.sync="drawer" :show-back-button="showBackButton" />
    <deprecation-banner v-if="user" />
    <task-drawer :value="taskId" :task-id="taskId" />
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      temporary
      :right="RTLmode"
      hide-overlay
      style="z-index: 1000"
      width="300"
    >
      <v-list nav dense>
        <div class="d-flex align-center justify-space-between mb-4 px-3 py-2">
          <v-icon small @click="drawer = false">$cancel</v-icon>
          <router-link
            class="mx-auto"
            :to="defaultRouteByRole"
            @click="display = 'listings'"
          >
            <img
              class="mt-2 mr-2"
              style="zoom: 0.7"
              :src="cloudinaryDelivery(logo, { width: 200 })"
              height="50"
            />
          </router-link>
          <locale-changer class="mx-2" />
        </div>
        <login-as-tenant v-if="canLoginAsTenant && !isAdminTenant" />
        <v-select
          v-if="user && isAdmin && !isBoomForHosts"
          :value="user.zone_id"
          :items="listingZones"
          :label="$t('Zone')"
          dense
          hide-details
          outlined
          class="pb-2 mt-1"
          @change="onZoneChange($event)"
        />
        <template v-for="(item, index) in filteredMenuItems">
          <v-list-group
            v-if="item.submenu"
            :key="index"
            :value="isGroupActive(item.submenu)"
            no-action
          >
            <template #activator>
              <v-list-item-action class="mr-1 ml-3">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="text-body-2 font-weight-medium dark700--text">
                    {{ $t(item.text) }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="child in item.filteredSubmenu"
              :key="child.title"
              v-bind="getLinkProps(child)"
              class="ps-12"
              active-class="menu-item-active"
            >
              <v-list-item-content>
                <v-list-item-title class="d-flex align-center">
                  <v-icon small class="me-2">{{ child.icon }}</v-icon>
                  <span class="text-body-2 font-weight-medium dark700--text">
                    {{ $t(child.text) }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="index"
            v-bind="getLinkProps(item)"
            active-class="menu-item-active"
          >
            <v-list-item-action class="mr-1 ml-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span class="text-body-2 font-weight-medium dark700--text">
                  {{ $t(item.text) }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-if="user" #append>
        <!-- View Switcher - available to all user roles except investors -->
        <div v-if="!isInvestor" class="px-4 pt-2 pb-2">
          <view-switcher />
        </div>

        <div v-if="user && user.super_admin" class="px-4 pb-2">
          <!-- Product Type - super admin only -->
          <div class="text-center">
            <v-chip
              :color="isBoomForHosts ? 'primary' : 'secondary'"
              label
              class="px-4"
            >
              {{ isBoomForHosts ? 'Boom-Host' : 'Boom-Pro' }}
            </v-chip>
          </div>
        </div>
        <v-list>
          <template>
            <v-divider />
            <v-list-item to="/dashboard/user-profile">
              <v-list-item-avatar>
                <user-avatar
                  :image="user.picture"
                  :name="`${user.first_name} ${user.last_name}`"
                  :role="user.role"
                  :size="40"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-if="user.first_name || user.last_name"
                  class="font-weight-light"
                >
                  {{ user.first_name }} {{ user.last_name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text-caption font-weight-light">
                    {{ user.email }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon small @click.prevent="logout">
                  <v-icon small>$logout</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </template>
    </v-navigation-drawer>
    <div v-if="loading" class="center-overlay">
      <LoaderAnimationPalms />
    </div>
    <video-popup v-if="$store.state.chosenVideo"></video-popup>
    <info-item-pop v-if="$store.state.chosenInfoItem" />
    <inbox-popup v-if="$store.state.chosenConversation"></inbox-popup>
    <listing-setup-task-thread v-if="$store.state.chosenListingSetupTask" />
    <server-error-modal />
    <div v-if="user" class="flex-fill">
      <router-view />
    </div>
    <vr-footer v-show="display === 'listings' && !loading && !noFooterPage" />
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from 'vuex'

import VrFooter from 'components/footer'
import { getV2BaseUrl } from '@/utils/v2-base-url'
import { resolveV2Redirect } from '@/utils/v2-route-mappings'
import CommonFunctions from 'components/mixins/common_functions'
import PermissionsMixin from 'components/mixins/permissions-mixin'
import UpdateMixin from 'components/mixins/update'
import LoaderAnimationPalms from 'components/loaders/loader-animation-palms'
import InfoItemPop from 'components/info-item-pop'
import ListingSetupTaskThread from 'components/listing-setup-task-thread'
import VideoPopup from 'components/video-popup'
import InboxPopup from 'components/inbox-popup'
import { getMenuItems } from '@/components/menu/menu-items'
import UserAvatar from 'components/common/user-avatar'
import AppHeader from 'components/layouts/app-header'
import Mention from 'quill-mention'
import Quill from 'quill'
import hotjar from '@/utils/hotjar'
import LocaleChanger from 'components/layouts/locale-changer.vue'
import TaskDrawer from 'components/listing-report/task-drawer.vue'
import LoginAsTenant from 'components/tenant-settings/login-as-tenant.vue'
import ServerErrorModal from 'components/common/server-error-modal.vue'
import DeprecationBanner from 'components/shared/deprecation-banner.vue'
import DeviceMixin from 'components/mixins/device-mixin'
import ViewSwitcher from 'components/shared/view-switcher.vue'
import boomLogo from '@/assets/images/Boom-logo_color.png'
import { canAccessBam } from '@/utils/bam-access'

Quill.register('modules/mention', Mention)
export default {
  components: {
    LoginAsTenant,
    TaskDrawer,
    LocaleChanger,
    AppHeader,
    LoaderAnimationPalms,
    'vr-footer': VrFooter,
    ListingSetupTaskThread,
    VideoPopup,
    InboxPopup,
    UserAvatar,
    InfoItemPop,
    ServerErrorModal,
    ViewSwitcher,
    DeprecationBanner,
  },
  mixins: [CommonFunctions, PermissionsMixin, UpdateMixin, DeviceMixin],
  data() {
    return {
      drawer: false,
      showBackButton: false,
      registration: null,
      updateExists: false,
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (
          to &&
          from &&
          to.name === from.name &&
          (!to.params.id || to.params.id == from.params.id)
        )
          return
        this.$store.commit('destroyCurrentEditListing')
        this.showBackButton =
          this.$router.history._startLocation !== to.fullPath
        if (to.path.includes('/field-management')) {
          this.$store.dispatch('getRequestsByFilter', {
            request_type: 'Repair',
          })
        } else if (to.path.includes('/listing-setup/')) {
          this.$store.dispatch('getListingSetup', to.path.split('/')[3])
        } else if (to.path.includes('/dashboard/pricing/')) {
          this.$store.dispatch('getListingPricing', to.path.split('/')[3])
        } else if (to.path.includes('/guests/')) {
          this.$store.dispatch('getCurrentGuest', to.path.split('/')[3])
        } else if (to.path.includes('/company-activity')) {
          this.$store.dispatch('getCompanyActivity')
        } else if (to.path === '/dashboard/experience-management') {
          this.$store.dispatch('getExperienceRequests')
        }
      },
    },
    shouldHideIntercom: {
      immediate: true,
      handler(val) {
        if (val) {
          document.documentElement.classList.add('intercom-hidden')
        } else {
          document.documentElement.classList.remove('intercom-hidden')
        }
      },
    },
  },
  beforeDestroy() {
    this.$store.dispatch('unsubscribeFromApplicationChannel')
    this.$store.dispatch('unsubscribeFromInquiryChannel')
  },
  async created() {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    try {
      await this.$store.dispatch('getConfiguration')
    } catch (err) {
      const status = err?.response?.status
      if (status === 502 || status === 503) {
        this.$store.dispatch('updateShowServerErrorModal')
        return
      } else {
        return this.$router.push('/login')
      }
    }
    await this.$store.dispatch('regions/getRegions')
    await this.$store.dispatch('zones/getZones')
    // await this.$store.dispatch('getAiPolicy')
    this.$store.dispatch('getBankAccount')
    const user = await this.$store.dispatch('getCurrentUser')

    // The router guard ran before this fetch resolved, so on a cold load it saw
    // no user and could not tell whether this route belongs to v2. Re-check now
    // that we know, otherwise a bookmarked or refreshed v1 URL stays on Vue even
    // for a user whose module is on v2 (#28127). Bail before the dispatches
    // below — we are leaving the page.
    const v2Url = resolveV2Redirect(this.$route.path, user)
    if (v2Url) {
      window.location.replace(v2Url)
      return
    }

    this.$i18n.locale = user.locale
    hotjar.identify(user)
    if (user.tenant.product_type === 'boom-host') {
      hotjar.event('boom_host_session_started')
    }
    this.$store.dispatch('getSettings')
    this.$store.dispatch('userGroups/getUserGroups')
    this.$store.dispatch('users/getAllUsers')
    this.$store.dispatch('users/getTeams')
    this.$store.dispatch('getPmsData')
    this.$store.dispatch('getUserNotifications')
    this.$store.dispatch('getListingsPicker')
    this.$store.dispatch('getListingsCities')
    this.$store.dispatch('getAllCities')
    this.$store.dispatch('storages/getStorages')
    this.$store.dispatch('businessModel/fetchBusinessModels')
    if (!this.isInvestor) {
      this.$store.dispatch('getListingTaskCatalogItems')
    }
    this.registerChannels()
    if (!this.isInvestor) {
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'rjv8g8a2',
        name: `${user.first_name} ${user.last_name}`, // Full name
        email: user.email, // the email for your user
        tenant_id: user.tenant_id,
        id: user.id,
        phone: user.phone,
        role: user.role,
        hide_default_launcher: this.isMobile,
        intercom_user_jwt: user.intercom_jwt,
      })
    }
  },
  computed: {
    ...mapState(['user', 'loading']),
    ...mapState('zones', ['zones']),
    logo() {
      return this.$store.state.app.configuration.logo_url || boomLogo
    },
    taskId() {
      return this.$route.query.reportTaskDrawer
    },
    shouldHideIntercom() {
      return this.isIntercomHidden || this.isMobile || this.isAgent
    },
    filteredMenuItems() {
      return this.filterMenuItems(
        getMenuItems(
          this.user?.tenant?.product_type,
          this.user?.module_versions
        )
      )
    },
    display: {
      get() {
        return this.$store.state.display
      },
      set(display) {
        this.$store.commit('updateDisplay', display)
      },
    },
    noFooterPage() {
      return ['lt-page', 'multi-calendar'].includes(this.$route.name)
    },
    isIntercomHidden() {
      return this.$store.state.app.configuration?.ui_settings?.hide_intercom
    },
    listingZones() {
      const availableZones = this.zones.map(r => ({
        text: r.name,
        value: r.id,
      }))
      return [{ text: 'Global', value: null }].concat(availableZones)
    },
  },
  methods: {
    ...mapActions([
      'subscribeToInquiryChannel',
      'subscribeToApplicationChannel',
    ]),
    getLinkProps(child) {
      if (child.v2) return { href: child.v2 }
      if (!child.value && child.value_v2) {
        return { href: `${getV2BaseUrl()}${child.value_v2}` }
      }
      return { to: child.value }
    },
    registerChannels() {
      this.subscribeToApplicationChannel()
      if (this.user.department === 'Sales') {
        this.subscribeToInquiryChannel()
      }
    },
    updateAvailable(event) {
      this.registration = event.detail
      this.updateExists = true
    },
    logout() {
      const routerElement = this.$router
      axios
        .post('/api/logout')
        .then(() => routerElement.push('/login'))
        .catch(() => ({}))
    },
    handleBack() {
      this.$router.back()
    },
    async onZoneChange(value) {
      await this.$store.dispatch('users/updateUserNew', {
        id: this.user.id,
        zone_id: value,
      })
      location.reload()
    },
    filterMenuItems(items = []) {
      return items.filter(item => {
        if (item.key === 'accounting' && this.hideFinancials) return false
        if (item.requiresBamAccess && !canAccessBam(this.user)) return false
        if (item.submenu) {
          item.active = true
          item.filteredSubmenu = this.filterMenuItems(item.submenu)
          return item.filteredSubmenu.length
        }
        if (this.user && this.user.is_demo) {
          return item.demo_only
        }
        if (item.abilityOrRole) {
          return (
            ((this.isAllowed(item.allowed_roles) &&
              this.isNotAllowed(item.not_allowed_roles)) ||
              this.hasAbility(item.abilities)) &&
            this.showModule(item.module)
          )
        }
        return (
          this.isAllowed(item.allowed_roles) &&
          this.isNotAllowed(item.not_allowed_roles) &&
          this.hasAbility(item.abilities) &&
          this.showModule(item.module)
        )
      })
    },
    isGroupActive(submenu) {
      return submenu.some(subItem => this.$route.path.includes(subItem.value))
    },
    handleExternalLink(event, url) {
      event.preventDefault()
      window.location.href = url
    },
  },
}
</script>

<style>
.intercom-lightweight-app {
  z-index: 3 !important;
}
.intercom-lightweight-app-launcher {
  left: 20px !important;
}

.intercom-hidden .intercom-lightweight-app {
  display: none !important;
}

/* Menu item spacing and shape */
.v-navigation-drawer .v-list-item {
  margin: 8px 8px !important;
  border-radius: 8px !important;
}

/* Active menu item background */
.menu-item-active {
  background-color: rgb(226 232 240) !important;
}

.menu-item-active:before {
  opacity: 0 !important;
}

/* Hover states */
.v-navigation-drawer
  .v-list-item:hover:not(.menu-item-active):not(.v-list-group__header) {
  background-color: rgba(226, 232, 240, 0.4) !important;
}

/* Group headers styling */
.v-navigation-drawer .v-list-group__header {
  margin: 8px 8px !important;
  border-radius: 8px !important;
}

.v-navigation-drawer .v-list-group__header:hover {
  background-color: rgba(226, 232, 240, 0.4) !important;
}

/* Remove default group header backgrounds */
.v-navigation-drawer .v-list-group--active > .v-list-group__header,
.v-navigation-drawer .v-list-group > .v-list-group__header:before {
  background-color: transparent !important;
}

/* Icon sizing with transform - only for actual menu items */
.v-navigation-drawer .v-list-item .v-icon,
.v-navigation-drawer .v-list-group__header .v-icon {
  color: rgba(0, 0, 0, 0.7) !important;
  transform: scale(1.25) !important;
  transform-origin: center !important;
}

/* Header icons should not be enlarged */
.v-navigation-drawer > .v-list > div > .v-icon {
  transform: none !important;
}

/* Text weight */
.v-navigation-drawer .v-list-item__title,
.v-navigation-drawer .text-body-2 {
  font-weight: 500 !important;
}
</style>
